<template>
  <FormItemWrapper>
    <FormItemLabel slot="label">
      {{ $t('formItemLabelConsumptionCategory') }}
    </FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipConsumptionCategory')"
      slot="tooltip"
      :content="$t('formItemTooltipConsumptionCategory')"
    />
    <el-radio-group v-model="consumtionType">
      <el-radio
        v-for="(item, index) in consumtionTypes"
        :key="`item-${index}`"
        :label="item.value"
      >
        {{ item.label }}
      </el-radio>
    </el-radio-group>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Radio, RadioGroup } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Radio);
Vue.use(RadioGroup);

export default {
  name: 'FilterMeterType',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    consumtionTypes() {
      return [
        {
          value: false,
          label: this.$t('formItemBigConsumers'),
        },
        {
          value: true,
          label: this.$t('formItemSmallConsumers'),
        },
      ];
    },
    consumtionType: {
      get() {
        return this.$store.state.filter.activeFilters.consumtionType;
      },
      set(value) {
        this.$store.commit('filter/SET_CONSUMPTION_TYPE', value);
      },
    },
  },
  watch: {
    consumtionType() {
      this.$store.commit('filter/SET_CONSUMPTION_TYPE', this.consumtionType);
    },
  },
};
</script>
